import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

export default function ModifyHTMLElements(props) {
  const currentFavicon = document.getElementById('favicon')
  const dispatch = useDispatch()
  const { details: { title, favicon } } = props
  const [previousTitle, setPreviousTitle] = useState(document.title);
  const [previousIcon, setPreviousIcon] = useState(currentFavicon.href);

  useEffect(() => {
    dispatch({
      type: "IN_SESSION",
      response: true
    })
    return () => {
      dispatch({
        type: "IN_SESSION",
        response: false
      })
    };
  }, []);

  useEffect(() => {
    if (document.title === title) return
    
    setPreviousTitle(document.title)
    setPreviousIcon(currentFavicon.href)
    
    document.title = title
    currentFavicon.href = favicon

    return () => {
      document.title = previousTitle
      currentFavicon.href = previousIcon
    };
  }, [title]);

  return (<React.Fragment />)
}
